import type { DefaultDtoType, Field } from "../Field";
import { initField } from "../Field";
import type { InferOutput } from "valibot";
import { fallback, object } from "valibot";
import { heading, label } from "../../utils/validation/base";
import { useTranslation } from "../../state/i18n";
import { TextInput } from "../../components/inputs/TextInput";
import { useFormServices } from "../../services/formServices";
import { SingleSelectInput } from "../../components/menu/Select";
import { HeaderPreview } from "../FieldPreviewComponents";
import PropertySection from "../PropertySection";
import { keyFromSelector } from "i18next";

const Schema = object({
  label_text: label(),
  size: fallback(heading(), "h2"),
});

export type HeaderFieldProperties = InferOutput<typeof Schema>;

const HeaderField: Field<HeaderFieldProperties, DefaultDtoType> = {
  type: "header",
  category: "layout",
  widget: "com.moreapps:header:1",
  schema: Schema,
  hasData: false,
  defaultProperties: () => ({ size: "h2" }),
  icon: "header",
  titleKey: keyFromSelector(($) => $.HEADER_FIELD_LABEL),
  descriptionKey: keyFromSelector(($) => $.HEADER_FIELD_DESCRIPTION),
  propertyKeys: {
    label_text: keyFromSelector(($) => $.FIELD_PROPERTY_HEADER_LABEL_TEXT),
    size: keyFromSelector(($) => $.FIELD_PROPERTY_SIZE),
  },
  PreviewContent: (props) => <HeaderPreview label={props.properties.label_text} size={props.properties.size} />,
  EditItem: (props) => {
    const { t } = useTranslation();
    const { fieldService } = useFormServices();

    return (
      <PropertySection>
        <TextInput
          label={t(props.propertyKeys.label_text)}
          value={props.data.properties.label_text}
          required
          onBlur={(e) => fieldService.setLabelProperty(props.uid, e.target.value)}
          errorMessage={props.getError("label_text")}
        />
        <SingleSelectInput
          label={t(props.propertyKeys.size)}
          value={props.data.properties.size}
          onSelect={(selectedOption) => props.setValue("size", selectedOption)}
          options={[
            { variant: "text", label: "h1", value: "h1" },
            { variant: "text", label: "h2", value: "h2" },
            { variant: "text", label: "h3", value: "h3" },
            { variant: "text", label: "h4", value: "h4" },
            { variant: "text", label: "h5", value: "h5" },
            { variant: "text", label: "h6", value: "h6" },
          ]}
          errorMessage={props.getError("size")}
          sameWidth
        />
      </PropertySection>
    );
  },
};

export default initField(HeaderField);
